import TagPolicy from './policies/tag.js';
import UserPolicy from './policies/user.js';
import PostPolicy from './policies/post.js';
import SupportPolicy from './policies/support.js';
import FAQPolicy from './policies/FAQ.js';
import CommentPolicy from './policies/comment.js';
import CategoryPolicy from './policies/category.js';
import FAQCategoryPolicy from './policies/FAQcategory.js';
import NotificationPolicy from './policies/notification.js';
import TermsAndConditionsPolicy from './policies/terms.js';
import axios from 'axios';

export default class Gate
{
  constructor()
  {
    this.policies = {
      tag: TagPolicy,
      user: UserPolicy,
      post: PostPolicy,
      support: SupportPolicy,
      FAQ: FAQPolicy,
      comment: CommentPolicy,
      category: CategoryPolicy,
      FAQcategory: FAQCategoryPolicy,
      notification: NotificationPolicy,
      terms: TermsAndConditionsPolicy,
    };
  }

  setUser(user)
  {
    this.user = user;
  }
  setUnreadTicketsCount(tickets_count)
  {
    const permission = {
      headers: {
        'X-Permission': 'all_tickets_list' 
      }
    };
    axios.get('/admin/support/unread-tickets-count',permission)
    .then((response) => {
      if (response.data.ticket_count) {
        $('span.unread_tickets_count').html(response.data.ticket_count);

      } 
    });
  }
  



  allow(action, type, model = null)
  {
    return this.policies[type][action](this.user, model);
  }

  deny(action, type, model = null)
  {
    return ! this.allow(action, type, model);
  }
}
